import { BreadcrumbModel, TelemetryProperties } from './models';
import { TelemetryScrubberService } from './telemetry-scrubber.service';
import { BreadcrumbCategory } from './enums';

const CAPACITY = 200;

// A fixed ring of recent events for crash reports; unbounded history would be the leak it exists to diagnose.
export class BreadcrumbBuffer {
  private readonly entries: BreadcrumbModel[] = [];
  private cursor: number = 0;

  public constructor(private readonly scrubber: TelemetryScrubberService) { }

  public add(t: number, cat: BreadcrumbCategory, msg: string, data: TelemetryProperties = {}): void {
    const entry = this.scrubber.scrubBreadcrumbs([{ t, cat, msg, data }])[0];

    if (this.entries.length < CAPACITY) {
      this.entries.push(entry);
    } else {
      this.entries[this.cursor] = entry;
    }

    this.cursor = (this.cursor + 1) % CAPACITY;
  }

  public snapshot(): BreadcrumbModel[] {
    // Once wrapped, the cursor is the oldest entry, so the ring is re-joined there to read oldest-first.
    const entries = this.entries.length < CAPACITY ? this.entries : [
      ...this.entries.slice(this.cursor), ...this.entries.slice(0, this.cursor)
    ];

    return this.scrubber.scrubBreadcrumbs(entries);
  }

  public clear(): void {
    this.entries.length = 0;
    this.cursor = 0;
  }
}
